import ReactDOM from 'react-dom/client';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import { TenantContext } from '../../../context/tenant-context';
import 'react-toastify/dist/ReactToastify.css';
import { v2Component } from '../../../index';
import { ProductImageV2 } from './product-image-v2';

export function initProductImage() {
  document.getElementsByName('product-image').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const { tenant, contextPath, productId, profile, ...props } = Object.assign({}, element.dataset) as any;
      root.render(
        v2Component(
          <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
            <ToastContainer />
            <ProductImageV2 productId={productId} profile={profile} {...props} />
          </TenantContext.Provider>,
        ),
      );

      const event = new CustomEvent('change');
      element.dispatchEvent(event);
    }
  });
}
